
export const packageValidationHelper = (addedPackages) => {
    var newPackages = [...addedPackages];
    newPackages.forEach((newPackage) => {
        newPackage.packageCountValidation = true;
        newPackage.typeValidation = true;
        newPackage.descriptionValidation = true;
        newPackage.grossweightValidation = true;
        newPackage.volumeValidation = true;
        newPackage.lengthValidation = true;
        newPackage.widthValidation = true;
        newPackage.heightValidation = true;

        newPackage.packageCount == 0 ? newPackage.packageCountValidation = false : newPackage.packageCountValidation = true;
        newPackage.type === 0 ? newPackage.typeValidation = false : newPackage.typeValidation = true;
        newPackage.description === '' ? newPackage.descriptionValidation = false : newPackage.descriptionValidation = true;

        if (newPackage.volume != 0) {
            //Volume has been entered so check for a Weight
            newPackage.grossweight == 0 ? newPackage.grossweightValidation = false : newPackage.grossweightValidation = true;
        }

        if (newPackage.grossweight != 0) {
            //Weight has been entered so check for a Volume
            newPackage.volume == 0 ? newPackage.volumeValidation = false : newPackage.volumeValidation = true;
        }

        if (newPackage.volume == 0) {
            //Volume has not been added so check the weight/height/width/length.
            newPackage.grossweight == 0 ? newPackage.grossweightValidation = false : newPackage.grossweightValidation = true;
            newPackage.length == 0 ? newPackage.lengthValidation = false : newPackage.lengthValidation = true;
            newPackage.width == 0 ? newPackage.widthValidation = false : newPackage.widthValidation = true;
            newPackage.height == 0 ? newPackage.heightValidation = false : newPackage.heightValidation = true;

            if (newPackage.grossweightValidation === true && newPackage.lengthValidation === true
                && newPackage.widthValidation === true && newPackage.heightValidation === true) {
                newPackage.volumeValidation = true;
            }
            else {
                newPackage.volumeValidation = false;
            }
        }

        if (newPackage.packageCountValidation === true && newPackage.typeValidation === true && newPackage.descriptionValidation == true &&
            newPackage.grossweightValidation === true && newPackage.lengthValidation === true &&
            newPackage.widthValidation === true && newPackage.heightValidation === true && newPackage.volumeValidation === true) {
            newPackage.passValidation = true;
        }
        else {
            newPackage.passValidation = false;
        }
    });

    return newPackages;
};
